// Chain ids (hex) — split out of chains.ts so contracts/config.ts does not pull the AppKit network module.
export const baseChainId = '0x2105'; // Base mainnet (8453)
export const skaleChainId = '0x79f99296'; // SKALE Europa Hub (2046399126)
export const BASE_CHAIN_ID = 8453;
export const SKALE_CHAIN_ID = 2046399126;
